import { render } from "./separate.vue?vue&type=template&id=16e80d82&scoped=true"
import script from "./separate.vue?vue&type=script&lang=js"
export * from "./separate.vue?vue&type=script&lang=js"

import "./separate.vue?vue&type=style&index=0&id=16e80d82&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e80d82"]])

export default __exports__